import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import search_icon from "../../../common/assets/images/search-icon-new.png";
import { useDispatch } from "react-redux";
import { applyQueueFilters } from "../../../store/queueSlice";

const SearchAndFilter = ({ handleQueueSearch, queueSearchTerm,selectedPriority,setSelectedPriority,selectedStatus,setSelectedStatus }) => {
  const dispatch = useDispatch(); // assuming you're using Redux
  const handleFilterChange = (priority, is_active) => {
    const payload = {
        priority: priority,
        is_active: is_active,
    };
    dispatch(applyQueueFilters(payload));
  };

  const handlePrioritySelect = (priority) => {
    setSelectedPriority(priority);
    handleFilterChange(priority, selectedStatus?.value); // send both
  };

  const handleStatusSelect = (value,label) => {
    console.log(value,label,"status")
    setSelectedStatus({value,label});
    handleFilterChange(selectedPriority, value); // send both
  };

  return (
    <div className="search-filter-wrapper">
      <div className="d-flex align-items-center input-wrapper config-filter-search">
        <img src={search_icon} alt="search" />
        <input
          type="text"
          placeholder="Search speciality queues..."
          value={queueSearchTerm}
          onChange={handleQueueSearch}
        />
      </div>
      <Dropdown className="config-filter-dropdown">
        <Dropdown.Toggle className="config-filter-header">
          {selectedPriority || "All Priorities"}
        </Dropdown.Toggle>
        <Dropdown.Menu className="config-filter-menu">
          {["Urgent", "High", "Low", "Overdue", "Nil assigned"].map(
            (priority) => (
              <Dropdown.Item
                key={priority}
                onClick={() => handlePrioritySelect(priority)}
              >
                {priority}
              </Dropdown.Item>
            )
          )}
        </Dropdown.Menu>
      </Dropdown>

      <Dropdown className="config-filter-dropdown">
        <Dropdown.Toggle className="config-filter-header">{selectedStatus?.label || "All Status"}</Dropdown.Toggle>
        <Dropdown.Menu className="config-filter-menu">
          {[ { label: "Active", value: true },
            { label: "InActive", value: false },].map(({label,value}) => (
            <Dropdown.Item
              key={label}
              onClick={() => handleStatusSelect(value,label)}
            >
              {label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default SearchAndFilter;
